import uiIdlenessRulesTable from './idleness-rules-table/index.vue'
import uiActionsRulesTable from './actions-rules-table/index.vue'

export { 
    uiIdlenessRulesTable,
    uiActionsRulesTable,
}
